import { MessageSchema } from "@redotech/redo-model/agents/llm-messages";
import * as z from "zod/v4";

// Define schema for tool options
const toolOptionSchema = z
  .object({ isDisabled: z.boolean().optional() })
  .catchall(z.any());

// Define the schema for all tool options
const toolOptionsSchema = z.record(z.string(), toolOptionSchema);

export const sendMessage = {
  name: "sendMessage" as const,
  input: z.object({
    messages: z.array(MessageSchema),
    options: toolOptionsSchema.optional(),
  }),
  output: z.object({ messages: z.array(MessageSchema) }),
};
